import React, { useEffect, Fragment, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

import './styles.scss';

const VideoHelpModal = ({ show, onClose }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(show);
  }, [show, setShowModal]);

  return (
    <Fragment>
      {showModal && (
        <ConfirmDialog
          dialogClass="VideoHelp--modal"
          contentClass="VideoHelp--modal-content"
          title="Content & Skills Report Overview"
          id={uuidv4()}
          onClose={onClose}
          size="big"
        >
          <iframe
            src="https://fast.wistia.net/embed/iframe/e23xpavt42?seo=false&videoFoam=true"
            title="Content& Skills Report Overview for Students Video"
            allow="autoplay; fullscreen"
            allowTransparency="true"
            className="wistia_embed"
            name="wistia_embed"
            msallowfullscreen
            width="100%"
            height="100%"
          />
        </ConfirmDialog>
      )}
    </Fragment>
  );
};

VideoHelpModal.propTypes = {};

export default VideoHelpModal;
